import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import { getSortedPhases, initialAppointmentPhaseFilter } from "./FilterTypes/AppointmentPhaseFilterType";
import AppointmentPhase from "../../Atoms/AppointmentPhase";
import { FilterContext } from "../FilterContext";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";

const AppointmentPhaseFilter = () => {
  const title = RESX.Status.resxStatus;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("appointmentPhase", {
    getTitle: () => title,
    renderSelection: (filter) => <div>
      {getSortedPhases(filter)
        .map(phase => <span key={phase.value} className={`${phase.icon} margin-right`} title={phase.text} />)}
    </div>,
    hasValue: (filter) => filter.selectedPhases.length > 0,
    reset: () => initialAppointmentPhaseFilter,
    areEqual: (a, b) => a.selectedPhases.length === b.selectedPhases.length && a.selectedPhases.every((phase, index) => phase.value === b.selectedPhases[index].value)
  });
  useEffect(() => {
    setInitialValue("appointmentPhase", initialAppointmentPhaseFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedPhases, setSelectedPhases] = React.useState(initialAppointmentPhaseFilter.selectedPhases);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedPhases(getValue("appointmentPhase").selectedPhases);
    setPopupOpen(true);
  };

  const onPhaseToggle = (newPhase: server.dto.AppointmentPhase) => {
    const isSelected = selectedPhases.some(p => p.value === newPhase.value);
    const newSelection = isSelected
      ? selectedPhases.filter(p => p.value !== newPhase.value)
      : [...selectedPhases, newPhase];
    setSelectedPhases(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("appointmentPhase", { selectedPhases });
    setPopupOpen(false);
  };
  const checkedMap = new Set(selectedPhases.map(p => p.value));

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<>
        <div className="margin-bottom flex-column gap-small">
          {serverReference.appointmentPhases.map((phase, index) =>
            <AppointmentPhaseRow
              autoFocus={index === 0}
              key={phase.value}
              phase={phase}
              checked={checkedMap.has(phase.value)}
              onToggle={() => { onPhaseToggle(phase); }} />
          )}
        </div>

        <Button fluid onClick={() => onApply()} primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

const AppointmentPhaseRow = ({ autoFocus, phase, checked, onToggle }: { autoFocus?: boolean, phase: server.dto.AppointmentPhase, checked: boolean, onToggle: () => void }) => (
  <div>
    <Checkbox
      autoFocus={autoFocus}
      keyboardNavigationOptions={VerticalKeyboardNavigationGroup("appointmentPhases")}
      onChange={onToggle}
      checked={checked}
      label={<AppointmentPhase value={phase.value} displayLabel />}
    />
  </div>
);

export default AppointmentPhaseFilter;